











import { Component, Vue, Prop } from "vue-property-decorator"
import QuestionRawFormOption from './QuestionRawFormOption.vue'

@Component({
  components: {
    QuestionRawFormOption
  }
})
export default class QuestionRawFormOptions extends Vue {
  @Prop({ type: Array }) rawFormOptions!: { key: string; value: string | boolean | number | string[] }[]

  get syncedRawFormOptions() {
    return this.rawFormOptions
  }
  set syncedRawFormOptions(v) {
    this.$emit("update:raw-form-types", v)
  }
}
